<template>
  <v-container class="whitebackground pa-0" max-width="100%">
    <!-- My Plan Main Content -->
    <v-row>
      <v-col cols="12" v-if="twoOrMoreDebtsAndMinOneUnpaidDebt">
        <!-- Debt Info -->
        <MyPlanDebtInfo @show-debt-video="turnDebtVideoOn" @changeTab="changeTab" />
        <!-- Debt Stacking Plan -->
        <MyPlanDebtStackingPlan />
      </v-col>
      <!-- Create Your Plan -->
      <v-col cols="12" v-else>
        <v-row class="text-center">
          <v-col cols="12" class="pa-3 text-h3 mt-4">
            {{ $t('L_enter_your_current') }}
          </v-col>
          <v-col cols="12" class="mb-5">
            <OnexButton
              role="link"
              color="primary"
              @click="goToMyDebt"
              class="valignMiddle createYourPlanBtn"
            >
              {{ $t('L_create_your_plan') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Contact Rep Footer -->
    <ContactRepFooter v-if="agent" />

    <!-- Debt Stacking Video -->
    <v-dialog v-model="showDebtVideo" width="auto">
      <v-card width="100%" :max-width="$vuetify.display.xs ? '320px' : '770px'">
        <v-card-title>
          <v-row justify="space-between" align-content="center">
            <v-col cols="auto">
              <h1>{{ $t('L_Debt_Stacking') }}</h1>
            </v-col>
            <v-col cols="auto" align-self="center"><v-icon :icon="mdiClose" /></v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <VideoPlayer
            :video-url="$t('L_debt_stacking_videoUrl')"
            :closed-caption-url="$t('L_debt_stacking_closedCaptionUrl')"
            :poster-url="$t('L_debt_stacking_posterUrl')"
          />
        </v-card-text>
        <template v-slot:actions>
          <OnexButton class="ms-auto ma-4 pa-2" variant="elevated" @click="closeDebtVideo">{{
            $t('L_close')
          }}</OnexButton>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import ContactRepFooter from '@/components/ContactRep/ContactRepFooter.vue';
import { mapState, mapStores } from 'pinia';
import { useDebtSolutionsStore } from '../store/debtsolutions.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import MyPlanDebtInfo from './MyPlanDebtInfo.vue';
import MyPlanDebtStackingPlan from './MyPlanDebtStackingPlan.vue';
import { mdiClose } from '@mdi/js';
import { OnexButton } from '@primerica/onex-ui-lib';
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer.vue';

const componentOptions: ComponentOptions = {
  name: 'MyPlanTab',
  components: {
    MyPlanDebtInfo,
    MyPlanDebtStackingPlan,
    ContactRepFooter,
    OnexButton,
    VideoPlayer,
  },
  data: () => ({
    iSliderIndex: 0,
    contactYourRep: false,
    policy: {},
    showDebtVideo: false,
    mdiClose,
  }),
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(usePolicyStore, ['currentPolicy']),
    ...mapState(useDebtSolutionsStore, {
      step: 'step',
      planStatus: 'planStatus',
      hasNoPlan: 'hasNoPlan',
      hasActivePlan: 'hasActivePlan',
      hasCompletedPlan: 'hasCompletedPlan',
      twoOrMoreDebtsAndMinOneUnpaidDebt: 'twoOrMoreDebtsAndMinOneUnpaidDebt',
      unpaidDebts: 'unpaidDebts',
    }),
    ...mapState(useGlobalStore, ['agents', 'getAgent']),
    agent() {
      return this.agents?.length === 1 ? this.agents[0] : null;
    },
  },
  methods: {
    changeTab() {
      this.goToMyDebt();
    },
    goToMyDebt() {
      this.$emit('changeTab', 0);
    },
    turnDebtVideoOn() {
      this.showDebtVideo = true;
    },
    closeDebtVideo() {
      this.showDebtVideo = false;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};

export default defineComponent(componentOptions);
</script>

<style scoped lang="scss">
.whitebackground {
  background-color: white;
}
.backgroundGray {
  background-color: #eeeeee;
}
.valignMiddle {
  margin: auto !important;
}
.agentImage {
  height: 80px;
  vertical-align: middle;
}
.your_representative_can_help_css {
  color: #4a4a4a;
  font-size: 24px;
  line-height: 1.5;
}
.modal {
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  position: fixed; /* Stay in place */
  z-index: 11; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  padding-top: env(safe-area-inset-top); /* Ensures padding below the status bar/notch */
}

.alertModal {
  position: fixed;
  height: 500px;
  width: 760px;
  text-align: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: white;
}
.video {
  width: 650px;
  height: 392px;
  margin: auto;
  margin-top: 0px;
}
.iframeVideo {
  width: 100%;
  max-width: 770px;
  height: 390px;
}
.alertModalMobile {
  position: fixed;
  width: 320px;
  height: 235px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: white;
}
.videoMobile {
  width: 300px;
  height: 170px;
  margin: auto;
  margin-top: 0px;
}
.verbiagePara {
  color: #02579e;
  font-size: 24px;
  padding-left: 20px;
  width: 100%;
  height: 40px;
}
.infoTitle {
  float: right;
  position: relative;
}
.modal-content iframe {
  margin: 0 auto;
  display: block;
}
.videoCloseBtn {
  text-align: right;
  padding-right: 30px;
  font-size: 18px;
  color: #02579e;
  font-weight: 600;
}
.debtStackingLabel {
  text-align: left;
  float: left;
  font-weight: 600;
}
.moveXToRight {
  text-align: right;
  float: right;
  font-weight: 600;
  padding-right: 25px;
}
.createYourPlanBtn {
  width: 268px;
}
</style>
